"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adPlacements = void 0;
/**
 * File is fine, in sync with production.
 */
var adPlacements = {
    // Temp for ads in comments poc
    COMMENTS: "readingshort_comments",
    // STORY_LANDING
    STORY_LANDING_TOP: "storylanding_top",
    STORY_LANDING_BOTTOM: "storylanding_bottom",
    STORY_LANDING_BOTTOM_MWEB: "storylanding_bottom_mweb",
    // READING_SHORT DWEB
    READING_SHORT_TOP: "readingshort_top",
    READING_SHORT_BOTTOM: "readingshort_bottom",
    READING_SHORT_COMMENTS: "readingshort_comments",
    READING_SHORT_INLINE_COMMENTS: "readingshort_inline_comments",
    READING_SHORT_TOP_LOGGED_OUT: "readingshort_top_loggedout",
    READING_SHORT_BOTTOM_LOGGED_OUT: "readingshort_bottom_loggedout",
    READING_SHORT_COMMENTS_LOGGED_OUT: "readingshort_comments_loggedout",
    READING_SHORT_INLINE_COMMENTS_LOGGED_OUT: "readingshort_inline_comments_loggedout",
    // READING_SHORT MWEB
    READING_SHORT_TOP_MWEB: "readingshort_top_mweb",
    READING_SHORT_BOTTOM_MWEB: "readingshort_bottom_mweb",
    READING_SHORT_COMMENTS_MWEB: "readingshort_comments_mweb",
    READING_SHORT_INLINE_COMMENTS_MWEB: "readingshort_inline_comments_mweb",
    READING_SHORT_TOP_LOGGED_OUT_MWEB: "readingshort_top_loggedout_mweb",
    READING_SHORT_BOTTOM_LOGGED_OUT_MWEB: "readingshort_bottom_loggedout_mweb",
    READING_SHORT_COMMENTS_LOGGED_OUT_MWEB: "readingshort_comments_loggedout_mweb",
    READING_SHORT_INLINE_COMMENTS_LOGGED_OUT_MWEB: "readingshort_inline_comments_loggedout_mweb",
    // READING_LONG DWEB
    READING_LONG_TOP: "readinglong_top",
    READING_LONG_MID: "readinglong_mid",
    READING_LONG_BOTTOM: "readinglong_bottom",
    READING_LONG_COMMENTS: "readinglong_comments",
    READING_LONG_INLINE_COMMENTS: "readinglong_inline_comments",
    READING_LONG_TOP_LOGGED_OUT: "readinglong_top_loggedout",
    READING_LONG_MID_LOGGED_OUT: "readinglong_mid_loggedout",
    READING_LONG_BOTTOM_LOGGED_OUT: "readinglong_bottom_loggedout",
    READING_LONG_COMMENTS_LOGGED_OUT: "readinglong_comments_loggedout",
    READING_LONG_INLINE_COMMENTS_LOGGED_OUT: "readinglong_inline_comments_loggedout",
    // READING_LONG MWEB
    READING_LONG_TOP_MWEB: "readinglong_top_mweb",
    READING_LONG_MID_MWEB: "readinglong_mid_mweb",
    READING_LONG_BOTTOM_MWEB: "readinglong_bottom_mweb",
    READING_LONG_COMMENTS_MWEB: "readinglong_comments_mweb",
    READING_LONG_INLINE_COMMENTS_MWEB: "readinglong_inline_comments_mweb",
    READING_LONG_TOP_LOGGED_OUT_MWEB: "readinglong_top_loggedout_mweb",
    READING_LONG_MID_LOGGED_OUT_MWEB: "readinglong_mid_loggedout_mweb",
    READING_LONG_BOTTOM_LOGGED_OUT_MWEB: "readinglong_bottom_loggedout_mweb",
    READING_LONG_COMMENTS_LOGGED_OUT_MWEB: "readinglong_comments_loggedout_mweb",
    READING_LONG_INLINE_COMMENTS_LOGGED_OUT_MWEB: "readinglong_inline_comments_loggedout_mweb",
    // MREC
    MREC_TOP: "myworks_mediumrect_top",
    // LIBRARY DWEB
    LIBRARY_BANNER: "library_banner",
    // LIBRARY MWEB
    LIBRARY_BANNER_MWEB: "library_banner_mweb",
    // SEARCH TAG DWEB
    TAG_SEARCH: "tag_search",
    TAG_SEARCH_LOGGED_OUT: "tag_search_loggedout",
    // SEARCH DWEB
    SEARCH: "search",
    SEARCH_LOGGED_OUT: "search_loggedout",
    // NOTIFICATION ADS
    NOTIFICATIONS_TOP: "notifications_top",
    NOTIFICATIONS_MID: "notifications_mid"
};
exports.adPlacements = adPlacements;
